var map = {
	"./actions/aerosql.svg": [
		69260,
		9260
	],
	"./actions/amazon.svg": [
		89772,
		9772
	],
	"./actions/attributes.svg": [
		68148,
		8148
	],
	"./actions/balance.svg": [
		96525,
		6525
	],
	"./actions/balanceHistory.svg": [
		20222,
		222
	],
	"./actions/billing.svg": [
		88857,
		8857
	],
	"./actions/changeStatus.svg": [
		59456,
		9456
	],
	"./actions/clear.svg": [
		96090,
		6090
	],
	"./actions/collapse.svg": [
		16534,
		6534
	],
	"./actions/continue.svg": [
		30751,
		751
	],
	"./actions/copyright.svg": [
		18311,
		8311
	],
	"./actions/count.svg": [
		99572,
		9572
	],
	"./actions/create.svg": [
		24721,
		4721
	],
	"./actions/customerGroup.svg": [
		94768,
		4768
	],
	"./actions/delete.svg": [
		57487,
		7487
	],
	"./actions/demoEntities.svg": [
		31697,
		1697
	],
	"./actions/details.svg": [
		94616,
		4616
	],
	"./actions/download.svg": [
		49447,
		9447
	],
	"./actions/edit.svg": [
		72222,
		2222
	],
	"./actions/expand.svg": [
		94867,
		4867
	],
	"./actions/exportCSV.svg": [
		51766,
		1766
	],
	"./actions/exportData.svg": [
		53922,
		3922
	],
	"./actions/fetchRemoteMigration.svg": [
		48518,
		8518
	],
	"./actions/files.svg": [
		12777,
		2777
	],
	"./actions/filters.svg": [
		85078,
		5078
	],
	"./actions/group.svg": [
		70131,
		131
	],
	"./actions/groupBy.svg": [
		44004,
		4004
	],
	"./actions/killDemoProcess.svg": [
		9043,
		9043
	],
	"./actions/loginUser.svg": [
		79350,
		9350
	],
	"./actions/loyalty_program.svg": [
		90435,
		435
	],
	"./actions/mappings.svg": [
		87824,
		7824
	],
	"./actions/orderStatus.svg": [
		89718,
		9718
	],
	"./actions/personal_info.svg": [
		31971,
		1971
	],
	"./actions/recent.svg": [
		90177,
		177
	],
	"./actions/recount.svg": [
		3134,
		3134
	],
	"./actions/reload.svg": [
		38675,
		8675
	],
	"./actions/resetPacks.svg": [
		90648,
		648
	],
	"./actions/restart.svg": [
		83353,
		3353
	],
	"./actions/restartMigration.svg": [
		35050,
		5050
	],
	"./actions/savePacks.svg": [
		14521,
		4521
	],
	"./actions/smart.svg": [
		85226,
		5226
	],
	"./actions/stores.svg": [
		16821,
		6821
	],
	"./actions/subscribe.svg": [
		21458,
		1458
	],
	"./actions/ticket.svg": [
		631,
		631
	],
	"./actions/transaction.svg": [
		6767,
		6767
	],
	"./actions/viewDebug.svg": [
		61621,
		1621
	],
	"./actions/viewLogs.svg": [
		28750,
		8750
	],
	"./actions/viewMigration.svg": [
		49219,
		9219
	],
	"./answers/affiliate.svg": [
		78793,
		473
	],
	"./answers/agency.svg": [
		96329,
		6329
	],
	"./answers/directory.svg": [
		76742,
		6742
	],
	"./answers/freelancer.svg": [
		92989,
		2989
	],
	"./answers/hosting-vendor-partner.svg": [
		46413,
		6413
	],
	"./answers/hosting.svg": [
		95220,
		5220
	],
	"./answers/store-agency.svg": [
		8747,
		8747
	],
	"./answers/store-owner.svg": [
		14692,
		4692
	],
	"./answers/vendor.svg": [
		47533,
		7533
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 89156;
module.exports = webpackAsyncContext;